//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DictTag",
  props: {
    type: String,
    value: [Number, String, Boolean, Array]
  }
};